var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{staticClass:"breadcrumb",attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.levelList),function(item){return (item.path)?_c('el-breadcrumb-item',{key:item.path},[_c('router-link',{attrs:{"to":item.redirect||item.path}},[_vm._v(_vm._s(item.meta.title))])],1):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }